import type { TQrDesign } from '../services/types'

const SCANNABILITY_CHECK_TIMEOUT_MS = 5_000
const SCANNABILITY_CHECK_TIMED_OUT = Symbol('SCANNABILITY_CHECK_TIMED_OUT')

const getScannableImageSize = async (
	qrDesign: TQrDesign,
	getData: () => string | null | Promise<string | null>,
) => {
	const data = await getData()
	if (!data) {
		return null
	}
	const { getScannableLogoImageSize } = await import('../services/client')
	return getScannableLogoImageSize({ ...qrDesign, data })
}

export const withScannableLogo = async (
	qrDesign: TQrDesign | null,
	getData: () => string | null | Promise<string | null>,
) => {
	if (!qrDesign?.image?.selected && !qrDesign?.image?.uploaded) {
		return qrDesign
	}
	let timeoutId: ReturnType<typeof setTimeout> | undefined
	try {
		const imageSize = await Promise.race([
			getScannableImageSize(qrDesign, getData),
			new Promise<typeof SCANNABILITY_CHECK_TIMED_OUT>((resolve) => {
				timeoutId = setTimeout(
					() => resolve(SCANNABILITY_CHECK_TIMED_OUT),
					SCANNABILITY_CHECK_TIMEOUT_MS,
				)
			}),
		])
		if (imageSize === SCANNABILITY_CHECK_TIMED_OUT) {
			console.warn(
				`[withScannableLogo] Scannability check timed out after ${SCANNABILITY_CHECK_TIMEOUT_MS}ms, saving original design`,
			)
			return qrDesign
		}
		if (imageSize === null) {
			return qrDesign
		}
		return {
			...qrDesign,
			imageOptions: { hideBackgroundDots: true, margin: 0, imageSize },
		}
	} catch (error) {
		console.error(
			'[withScannableLogo] Failed checking QR scannability:',
			error,
		)
		return qrDesign
	} finally {
		clearTimeout(timeoutId)
	}
}
